import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'investigationService'
var path = '/Investigation/'
var isDebug = false

function put (http, investigation) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path + '?saveComponents=true', investigation)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + `Get?investigationId=${id}`)
}

function search (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'search by ' + searchObject.ProjectId)

    return http.post(path + 'Search', searchObject).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.reportDate = dateService.convertToDate(x.reportDate)
                if (x.fieldworkStartDate) {
                    x.fieldworkStartDate = dateService.convertToDate(x.fieldworkStartDate)
                }
                x.workflowStatusDate = dateService.convertToDate(x.workflowStatusDate)
            })
        }
        return response
    })
}

function searchForComplete (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'search by ' + searchObject.ProjectId)

    return http.post(path + 'SearchForComplete', searchObject).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.reportDate = dateService.convertToDate(x.reportDate)
                x.workflowStatusDate = dateService.convertToDate(x.workflowStatusDate)
            })
        }
        return response
    })
}

function searchByPlss (http, plssDto) {
    loggingService.log(isDebug, serviceName, 'search by PLSS')

    return http.post(path + 'SearchByPlss', plssDto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.reportDate = dateService.convertToDate(x.reportDate)
                x.workflowStatusDate = dateService.convertToDate(x.workflowStatusDate)
            })
        }
        return response
    })
}

function todo (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'todo')

    return http.post(path + 'Todo', searchObject).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.reportDate = dateService.convertToDate(x.reportDate)
                x.workflowStatusDate = dateService.convertToDate(x.workflowStatusDate)
            })
        }
        return response
    })
}

function setUndertaking (http, investigationSetUndertaking) {
    loggingService.log(isDebug, serviceName, `set undertaking by : Undertaking ID: ${investigationSetUndertaking.undertakingId}
        on InvestigationId: ${investigationSetUndertaking.investigationId}`)
    return http.put(path + 'SetUndertaking', investigationSetUndertaking)
}

function removeUndertaking (http, investigationSetUndertaking) {
    loggingService.log(isDebug, serviceName, `remove undertaking by : Undertaking ID: ${investigationSetUndertaking.undertakingId}
        on InvestigationId: ${investigationSetUndertaking.investigationId}`)
    return http.put(path + 'RemoveUndertaking', investigationSetUndertaking)
}

function createE106Investigation (http, projectId) {
    loggingService.log(isDebug, serviceName, `createE106Investigation - projectId: ${projectId}`)
    return http.put(path + `CreateE106Investigation?projectId=${projectId}`)
}

function investigationSummaryReportGen (http, invId, siteTrsList, includeSiteForms = true) {
    return http.post(path + `InvestigationSummaryReportGen?investigationId=${invId}&includeSiteForms=${includeSiteForms}`, siteTrsList, { responseType: 'arraybuffer' })
}

function putPlss (http, investigationId, plss) {
    loggingService.log(isDebug, serviceName, 'putPlss - investigationId: ' + investigationId + ', plss: ' + plss)

    var data = {
        parentId: investigationId,
        parentType: 'Investigation',
        plssLocation: plss,
        sections: plss.Sections
    }

    return http.put(path + 'PutPlss', data)
}

function listInvestigationPlssLocationResultDto (http, investigationId) {
    loggingService.log(isDebug, serviceName, 'listInvestigationPlssLocationResultDto')

    return http.get(path + 'ListInvestigationPlssLocationResultDto?InvestigationId=' + investigationId).then(response => {
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
        })
        return response
    })
}

function deletePlssLocation (http, investigationPlssLocationId) {
    loggingService.log(isDebug, serviceName, 'deletePlssLocation, investigationPlssLocationId: ' + investigationPlssLocationId)
    return http.delete(path + 'deletePlss?InvestigationPlssLocationId=' + investigationPlssLocationId)
}

function deleteInvestigation (http, investigationId) {
    loggingService.log(isDebug, serviceName, 'deleteInvestigation, investigationId: ' + investigationId)
    return http.get(path + 'deleteInvestigation?investigationId=' + investigationId)
}

function getFieldChecked (http, investigationId) {
    loggingService.log(isDebug, serviceName, 'getFieldChecked, investigationId: ' + investigationId)
    return http.get(path + 'getFieldChecked?investigationId=' + investigationId)
}

function saveFieldChecked (http, investigationFieldCheckedDto) {
    loggingService.log(isDebug, serviceName, 'saveFieldChecked')
    return http.put(path + 'saveFieldChecked', investigationFieldCheckedDto)
}

function getRelatedItemWorkflows (http, investigationId) {
    loggingService.log(isDebug, serviceName, 'getRelatedItemWorkflows, investigationId: ' + investigationId)
    return http.get(path + `getRelatedItemWorkflows?investigationId=${investigationId}`)
}

function listInvMigrationRefs (http, investigationId) {
    return http.get(path + 'ListInvestigationMigrationRefs?investigationId=' + investigationId)
}

function generateCsv (http, data) {
    loggingService.log(isDebug, serviceName, 'Generating CSV')
    return http.put(path + '/GenerateCsv', data)
}

function saveBacklog (http, investigation) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path + 'SaveBacklog', investigation)
}

function addFileSearchSnrSites (http, investigation) {
    loggingService.log(isDebug, serviceName, 'addFileSearchSnrSites')
    return http.post(path + 'AddFileSearchAndSnrSitesToInvestigation', investigation)
}

export default {
    put: put,
    get: get,
    search: search,
    searchForComplete: searchForComplete,
    searchByPlss: searchByPlss,
    todo: todo,
    setUndertaking: setUndertaking,
    removeUndertaking: removeUndertaking,
    createE106Investigation: createE106Investigation,
    investigationSummaryReportGen: investigationSummaryReportGen,
    putPlss: putPlss,
    listInvestigationPlssLocationResultDto: listInvestigationPlssLocationResultDto,
    deletePlssLocation: deletePlssLocation,
    deleteInvestigation: deleteInvestigation,
    saveFieldChecked: saveFieldChecked,
    getFieldChecked: getFieldChecked,
    getRelatedItemWorkflows: getRelatedItemWorkflows,
    listInvMigrationRefs: listInvMigrationRefs,
    generateCsv: generateCsv,
    saveBacklog: saveBacklog,
    addFileSearchSnrSites: addFileSearchSnrSites
}



// WEBPACK FOOTER //
// ./src/services/investigationService.js